import styled from "styled-components"

const Container = styled.div`
    width: 100%;
    background-color: var(--primary-royal-blue);
    color: #fff;
    display: flex;
    place-content: center;
    gap: 4px;
    padding: 20px;
    & > b {
        color: var(--primary-pistachio);
    }
`

export default function Footer () {
    return (
        <Container>
            Legales <b>@claimsasap</b>/ Aviso de privacidad
        </Container>
    )
}
